import { GroupMetadata } from '../interfaces/group-metadata';
import { ArrayHelper } from '../../shared/utils/ArrayHelper';

export class ImpersonatedFilterConfiguration {
  public filteredContractsByCity: string[];
  public availableContracts: string[];
  public availableCities: string[];

  get selectedCity(): string {
    return this._selectedCity;
  }

  set selectedCity(value: string) {
    this._selectedCity = value;
    this.filterContractsByCity();
  }

  private readonly _impersonatedGroup: GroupMetadata;
  private _selectedCity: string;

  constructor(impersonatedGroup: GroupMetadata) {
    this._impersonatedGroup = impersonatedGroup;

    this.availableContracts =
      impersonatedGroup?.contractedUnits
        ?.filter(
          (value, index, self) =>
            self.findIndex(v => v.contractNumber === value.contractNumber) === index
        )
        ?.map(contract => contract.contractNumber) || [];
    this.filteredContractsByCity = this.availableContracts;

    this.availableCities = ArrayHelper.distinctValues(
      this._impersonatedGroup?.contractedUnits?.map(m => m.city) || []
    );
  }

  private filterContractsByCity(): void {
    if (this._selectedCity) {
      this.filteredContractsByCity = this._impersonatedGroup.contractedUnits
        .filter(contract => contract.city === this._selectedCity)
        .filter(
          (value, index, self) =>
            self.findIndex(v => v.contractNumber === value.contractNumber) === index
        )
        .map(contract => contract.contractNumber);
    } else {
      this.filteredContractsByCity = this.availableContracts;
    }
  }
}
